module.exports = __webpack_public_path__ + "images/plus_small-b4732b63d6231c09c56ca2bb32a20be4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/plus_small.svg
// module id = 232
// module chunks = 0